<div class="card">
  <h3 class="card__title">Deployment Status</h3>
  <div class="hbars">
    <div
      class="hbar"
      *ngFor="let row of deploymentStatuses"
      [class.is-active]="activeDeploymentStatus === row.name"
      tabindex="0"
      (click)="deploymentStatusSelect.emit(row.name)"
      (keydown.enter)="deploymentStatusSelect.emit(row.name)"
    >
      <div class="hbar__lbl">
        <span class="hbar__name" [title]="row.name">{{ row.name }}</span>
        <span class="hbar__val">{{ row.pct }}%</span>
      </div>
      <div class="hbar__track">
        <div class="hbar__fill" [style.width.%]="row.pct" [style.background]="colorFor(row.name)"></div>
      </div>
    </div>
  </div>
</div>
